import { Link } from 'react-router-dom';

const footerLinks = [
  { to: '/', label: '首页' },
  { to: '/category', label: '影视分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于我们' },
];

const categoryLinks = [
  { to: '/category?cat=traditional', label: '传统伦理剧' },
  { to: '/category?cat=modern', label: '现代伦理剧' },
  { to: '/category?cat=film', label: '伦理电影' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-film-line" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">韩国伦理</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200/80 max-w-md">
              专注韩国伦理影视剧情及推荐，收录传统伦理剧、现代伦理剧与伦理电影，为你提供清晰的剧情介绍与值得信赖的作品推荐。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">网站导航</h3>
            <ul className="space-y-2.5">
              {footerLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">热门分类</h3>
            <ul className="space-y-2.5">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300/70">
            © {new Date().getFullYear()} 韩国伦理. 本站内容仅供影视资讯参考与浏览。
          </p>
          <p className="text-xs text-primary-300/70">本站为影视推荐演示站点，不提供任何影视资源下载。</p>
        </div>
      </div>
    </footer>
  );
}